import store from "@/store";

const PREFERRED_EXIT_MESSAGE =
  "Parece que você tem alterações não salvas. Tem certeza de que deseja sair?";

// Source: https://stackoverflow.com/questions/24081699/why-onbeforeunload-event-is-not-firing
export const beforeUnloadHandler = (e) => {
  if (!store.getters.hasPendingSubmissions) {
    return null;
  }

  (e || window.event).returnValue = PREFERRED_EXIT_MESSAGE; //Gecko + IE
  return PREFERRED_EXIT_MESSAGE; //Gecko + Webkit, Safari, Chrome etc.
};

window.addEventListener("beforeunload", beforeUnloadHandler);
